export const Select: React.FC<
  React.HTMLAttributes<HTMLSelectElement> & {
    options?: ({ label: string; value: string } | [string, string] | string)[];
    blankOption?: string;
  }
> = ({ options, blankOption, ...htmlAttrs }) => (
  <select
    className='w-80 appearance-none rounded-md border border-gray-ccc bg-down-bracket bg-right bg-no-repeat py-2 pl-3 pr-12'
    style={{
      backgroundSize: '1.5rem',
      backgroundPosition: 'top 50% right 0.75rem',
    }}
    {...htmlAttrs}
  >
    {blankOption && <option value={''}>{blankOption}</option>}
    {options?.map((option, i) => (
      <option
        key={i}
        value={
          typeof option === 'string'
            ? option
            : Array.isArray(option)
            ? option[0]
            : option.value
        }
      >
        {typeof option === 'string'
          ? option
          : Array.isArray(option)
          ? option[1]
          : option.label}
      </option>
    ))}
  </select>
);
